$ ->

  # used for situations where there's a link that is responsible for
  # showing a hidden div or section of a page
  $(document).on "click", "[data-trigger]", (e) ->
    e.preventDefault()
    e.stopPropagation()

    triggerable = $(this).data("trigger")
    $triggerable = $("[data-triggerable=" + triggerable + "]")
    shouldAnimate = !!$triggerable.data("animate")

    shouldHideSelf = ($(this).data("hide-self") == null || !!$(this).data("hide-self"))

    if (shouldHideSelf)
      $(this).hide()

    if shouldAnimate
      $triggerable.slideToggle(150)
    else
      $triggerable.toggle()

  # responsible for the "cancel" operation of triggerable items; this will
  # re-show the originally clicked link, and re-hide the hidden div/section
  $("[data-trigger-cancel]").on "click", (e) ->
    e.preventDefault()

    trigger = $(this).data("trigger-cancel")

    $("[data-trigger=" + trigger + "]").show()
    $("[data-triggerable=" + trigger + "]").toggle()